import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class TaskStatusService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async getTaskStatuses() {
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/TaskStatus",
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/taskStatusService.js